import React from 'react';

import Profile from './Profile';
import Payments from './Payments';
import Notifications from './Notifications';
import Plans from './Plans';

function Account() {
  return (
    <>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <h1 className="text-xl text-gray-100 font-bold">Profile information</h1>
          <p className="mt-1 text-sm/6 text-gray-500">
            Update your account details and email address.
          </p>
        </div>
        <div className="col-span-2">
          <Profile />
        </div>
      </div>

      <hr className="bg-gray-100 h-px my-8 border-0" />

      <div className="grid grid-cols-3 gap-4">
        <div>
          <h1 className="text-xl text-gray-100 font-bold">Security information</h1>
          <p className="mt-1 text-sm/6 text-gray-500">Access Token, Secret</p>
        </div>
        <div className="col-span-2">
          <Notifications />
        </div>
      </div>

      <hr className="bg-gray-100 h-px my-8 border-0" />

      <div className="grid grid-cols-3 gap-4">
        <div>
          <h1 className="text-xl text-gray-100 font-bold">Shop</h1>
          <p className="mt-1 text-sm/6 text-gray-500">Charge more requests. Will be more</p>
        </div>
        <div className="col-span-2">
          <Plans />
        </div>
      </div>

      <hr className="bg-gray-100 h-px my-8 border-0" />

      <div className="grid grid-cols-3 gap-4">
        <div>
          <h1 className="text-xl text-gray-100 font-bold">Payments</h1>
          <p className="mt-1 text-sm/6 text-gray-500">Payment history log</p>
        </div>
        <div className="col-span-2">
          <Payments />
        </div>
      </div>
    </>
  );
}

export default Account;
